import { PDF_VIEWER_SELECTION_AREA_BOX_STYLE_PROPERTY_BY_COORDINATE } from '../../PdfViewerSelectionAreaBox'

export function transformSelectAreaCoordinatesToPercentCoordinates(
  coordinates,
  pdfPageCoordinates
) {
  const pageWidth = pdfPageCoordinates.width
  const pageHeight = pdfPageCoordinates.height
  const boxLeft = coordinates.x - pdfPageCoordinates.x
  const boxTop = coordinates.y - pdfPageCoordinates.y

  const topLeft = {
    x: boxLeft / pageWidth,
    y: boxTop / pageHeight,
  }
  const topRight = {
    x: (boxLeft + coordinates.width) / pageWidth,
    y: topLeft.y,
  }
  const bottomRight = {
    x: topRight.x,
    y: (boxTop + coordinates.height) / pageHeight,
  }
  const bottomLeft = { x: topLeft.x, y: bottomRight.y }

  return [topLeft, topRight, bottomRight, bottomLeft]
}

export function transformPercentCoordinatesToSelectAreaCoordinates(
  coordinates,
  pdfPageCoordinates
) {
  const [topLeft, topRight, bottomRight] = coordinates

  const x = topLeft.x * pdfPageCoordinates.width + pdfPageCoordinates.x
  const y = topLeft.y * pdfPageCoordinates.height + pdfPageCoordinates.y

  return {
    height:
      bottomRight.y * pdfPageCoordinates.height - y + pdfPageCoordinates.y,
    width: topRight.x * pdfPageCoordinates.width - x + pdfPageCoordinates.x,
    x,
    y,
  }
}

export function getPdfDocumentCoordinatesForSelectionBox({ container, page }) {
  const pageRect = page.getBoundingClientRect()
  const containerRect = container.getBoundingClientRect()

  const width = pageRect.width
  const height = pageRect.height
  const left = pageRect.left - containerRect.left
  const top = pageRect.top - containerRect.top
  const right = left + width
  const bottom = top + height

  return {
    bottom,
    height,
    left,
    right,
    top,
    width,
    x: left,
    y: top,
  }
}

export function getSelectBoxCoordinates(selectBoxRef) {
  const styleLeft = parseFloat(selectBoxRef.current.style.left)
  const styleTop = parseFloat(selectBoxRef.current.style.top)

  const left = isNaN(styleLeft) ? selectBoxRef.current.offsetLeft : styleLeft
  const top = isNaN(styleTop) ? selectBoxRef.current.offsetTop : styleTop

  return {
    left,
    top,
  }
}

export function checkIsSelectBoxDisabled(selectBoxElement) {
  return selectBoxElement.dataset.disabled === 'true'
}

export function getSelectBoxStyleProperty(coordinateKey) {
  return (
    PDF_VIEWER_SELECTION_AREA_BOX_STYLE_PROPERTY_BY_COORDINATE[coordinateKey] ??
    coordinateKey
  )
}

// the lower bound wins when the box does not fit the page at all, so a box
// wider than the page still starts at its left edge instead of past it
export function getDraggedSelectBoxCoordinates({
  boxSize,
  delta,
  pageRect,
  startCoordinates,
}) {
  return {
    x: Math.max(
      pageRect.x,
      Math.min(startCoordinates.x + delta.x, pageRect.right - boxSize.width)
    ),
    y: Math.max(
      pageRect.y,
      Math.min(startCoordinates.y + delta.y, pageRect.bottom - boxSize.height)
    ),
  }
}

export function getResizedSelectBoxSize({
  boxCoordinates,
  delta,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  pageRect,
  startSize,
}) {
  return {
    height: Math.min(
      Math.max(startSize.height + delta.y, minHeight),
      Math.min(maxHeight, pageRect.bottom - boxCoordinates.top)
    ),
    width: Math.min(
      Math.max(startSize.width + delta.x, minWidth),
      Math.min(maxWidth, pageRect.right - boxCoordinates.left)
    ),
  }
}
